import type {NotFoundRouteProps} from "@tanstack/react-router";
import {NonEmbeddedNotFoundComponent} from "~/components/routerHelpers/nonEmbeddedNotFoundComponent";
import {Route} from "./__root";

export function NotFoundComponent({data, isNotFound, routeId}: NotFoundRouteProps) {
    return (
        <NonEmbeddedNotFoundComponent
            data={data}
            isNotFound={isNotFound}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
            routeId={routeId}
            //
        />
    );
}
